module.exports = __webpack_public_path__ + "static/media/tz.52d06401.svg";